import { Calendar } from '@/components/Common/Calendar/Calendar';
import { Header } from '@/components/Layout/Header/Header';
import DashboardStats from '@/components/Views/Dashboard/DashboardStats';
import dateIcon from '@/assets/icons/date.svg';
const Dashboard = () => {
  return (
    <div>
      <Header userName="Mas Aly" role="Admin">
        <Calendar type="range" name="range" label="Filtrer par periode" dateIcon={dateIcon} />
      </Header>
      <DashboardStats />
    </div>
  );
};

export default Dashboard;
